import axiosInstance from "../../_utils/axiosConfig";
export const home = async ()=>{
    try{
         const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/home`);
         return response.data;
    }catch(error)
    {
        console.log("Erreur lors de la recuperation")
    }
}